export function openTemplates(): void {
    window.open("https://www.glideapps.com/templates", "_blank");
}
